<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-user-role-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Attach Role
            </h4>
          </div>

          <LoadingSpinner v-if="loading"/>

          <div v-else class="modal-body">
            <SelectFormGroup
                v-model="data.role_id"
                name="role_id"
                label="Role"
                :error="(errors.role_id || [])[0]"
                :options="roleOptions"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import LoadingSpinner from "../../../Layout/LoadingSpinner.vue";

export default {
  components: {LoadingSpinner, SelectFormGroup},

  mixins: [Errors],

  props: {
    user: {
      required: true
    }
  },

  data() {
    return {
      data: {},

      roles: null,

      loading: true,
    }
  },

  mounted() {
    this.listenForClose()

    this.load()
  },

  computed: {
    roleOptions() {
      return this.roles.map(role => ({value: role.id, label: role.attributes.name}))
    }
  },

  methods: {
    load() {
      http.get('/api/v2/roles').then(response => {
        this.roles = response.data.data

        this.loading = false
      })
    },

    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/users/' + this.user.id +'/roles', this.data)
          .then(response => {
            notify.success('The role was attached to the user')

            this.$emit('created', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
